import e, { useState as t, memo as r, useCallback as o } from "react";
import n from "classnames";
import { useFormikContext as a, useField as i, getIn as l, Form as p } from "formik";
import c from "lodash.omit";
import m from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDropzone as u } from "react-dropzone";
import { PhoneInput as d } from "react-phonenr-input";

function s(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
      var r = [],
          o = !0,
          n = !1,
          a = void 0;

      try {
        for (var i, l = e[Symbol.iterator](); !(o = (i = l.next()).done) && (r.push(i.value), !t || r.length !== t); o = !0) {
          ;
        }
      } catch (e) {
        n = !0, a = e;
      } finally {
        try {
          o || null == l.return || l.return();
        } finally {
          if (n) throw a;
        }
      }

      return r;
    }
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}

function f(e, t) {
  if (null == e) return {};

  var r,
      o,
      n = function (e, t) {
    if (null == e) return {};
    var r,
        o,
        n = {},
        a = Object.keys(e);

    for (o = 0; o < a.length; o++) {
      r = a[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    }

    return n;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);

    for (o = 0; o < a.length; o++) {
      r = a[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
  }

  return n;
}

var h = function h(t) {
  var r = t.hintMsg,
      o = t.errorMsg;
  return e.createElement("span", {
    className: n({
      hint: !!r,
      error: !!o
    })
  }, o || r);
};

h.defaultProps = {
  hintMsg: null,
  errorMsg: null
};

var b = function b(e, r) {
  var o = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
      n = arguments.length > 3 ? arguments[3] : void 0,
      p = arguments.length > 4 ? arguments[4] : void 0,
      c = i(e),
      m = s(c, 1),
      u = m[0],
      d = a(),
      f = d.values,
      h = t(!1),
      b = s(h, 2),
      g = b[0],
      k = b[1],
      w = function w(e) {
    k("onAutoFillStart" === e.animationName);
  },
      y = function y() {
    n && n(), k(!0);
  },
      x = function x() {
    p && p(), u.onBlur(e), k(!1);
  },
      v = l(f, e),
      N = g || !!v || !!r || !(!o || !v);

  return [N, w, y, x];
},
    g = function g() {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "input";
  return function (o) {
    var i = function i(r) {
      var i = r.name,
          p = r.label,
          m = r.hint,
          u = r.placeholder,
          d = r.type,
          f = r.disabled,
          g = r.required,
          k = r.style,
          w = r.format,
          y = r.onFocus,
          x = r.onBlur,
          v = s(b(i, u, f, y, x), 4),
          N = v[0],
          E = v[1],
          z = v[2],
          F = v[3],
          O = a(),
          P = O.errors,
          j = O.touched,
          C = l(P, i),
          L = d && "hidden" === d,
          I = l(j, i) && C ? C : null,
          S = "phoneInput" === t && "INTERNATIONAL" === w,
          T = c(r, ["hint", "label", "onFocus", "onBlur"]);
      return e.createElement("div", {
        className: n("form-element", t, {
          hasError: !!I,
          hidden: L
        })
      }, e.createElement("div", {
        className: n("".concat(t, "-wrapper"), {
          isDisabled: f
        })
      }, p && e.createElement("span", {
        className: n("label", {
          hide: N,
          moveLabel: S
        })
      }, "".concat(p).concat(g ? " *" : "")), e.createElement(o, Object.assign({
        onAnimationStart: E,
        onFocus: z,
        onBlur: F,
        style: k
      }, T))), !!I && e.createElement(h, {
        errorMsg: I
      }), !!m && e.createElement(h, {
        hintMsg: m
      }));
    };

    return i.defaultProps = {
      label: null,
      hint: null,
      placeholder: null,
      type: null,
      disabled: !1,
      required: !1,
      style: null,
      format: "INTERNATIONAL",
      onFocus: null,
      onBlur: null
    }, r(i);
  };
},
    k = function k(r) {
  var o = r.name,
      i = r.id,
      p = r.suggestions,
      c = r.className,
      m = r.style,
      u = f(r, ["name", "id", "suggestions", "className", "style"]),
      d = a().values,
      h = function (e, r) {
    var o = a(),
        n = o.setFieldValue,
        i = o.setFieldTouched,
        l = s(t(0), 2),
        p = l[0],
        c = l[1],
        m = s(t(null), 2),
        u = m[0],
        d = m[1],
        f = s(t(!1), 2),
        h = f[0],
        b = f[1];
    return [p, u, h, function (t) {
      var o = t.currentTarget.value,
          a = r.filter(function (e) {
        return e.toLowerCase().startsWith(o.toLowerCase());
      });
      c(0), d(a), b(!0), n(e, o), i(e, !0);
    }, function (t) {
      c(0), d(null), b(!1), n(e, t.currentTarget.innerText), i(e, !0);
    }, function (t) {
      if (13 === t.keyCode) {
        if (t.preventDefault(), "" === t.currentTarget.value) return;
        b(!1), n(e, u[p]), i(e, !0);
      } else if (38 === t.keyCode) {
        var r = u.length;
        c(0 === p ? r - 1 : p - 1);
      } else if (40 === t.keyCode) {
        var o = u.length;
        c(p === o - 1 ? 0 : p + 1);
      }
    }];
  }(o, p),
      b = s(h, 6),
      g = b[0],
      k = b[1],
      w = b[2],
      y = b[3],
      x = b[4],
      v = b[5];

  return e.createElement(e.Fragment, null, e.createElement("input", Object.assign({}, u, {
    id: i || o,
    name: o,
    className: c,
    style: m,
    onChange: y,
    onKeyDown: v,
    value: l(d, o),
    type: "text",
    tabIndex: "0"
  })), w && !!l(d, o) && e.createElement("ul", {
    className: "suggestions"
  }, null == k ? void 0 : k.map(function (t, r) {
    return e.createElement("li", {
      className: n({
        "suggestion-active": r === g
      }),
      key: t,
      onClick: x,
      onKeyPress: x
    }, t);
  })));
};

k.defaultProps = {
  className: null,
  style: null,
  disabled: !1,
  id: null,
  label: null,
  placeholder: null,
  hint: null,
  required: !1
};

var w = g("autocomplete")(k),
    y = function y(t) {
  var r = t.children,
      o = t.className,
      a = t.style,
      i = t.disabled,
      l = t.onClick,
      p = t.type,
      c = f(t, ["children", "className", "style", "disabled", "onClick", "type"]);
  return e.createElement("button", Object.assign({}, c, {
    className: n("form-element btn", o, {
      isDisabled: i
    }),
    style: a,
    onClick: l,
    type: p,
    disabled: i
  }), r);
};

y.defaultProps = {
  children: null,
  className: null,
  style: null,
  disabled: !1,
  type: "button"
};

var x = r(y),
    v = function v(t) {
  var r = t.disabled,
      n = t.id,
      i = t.name,
      p = t.text,
      c = t.className,
      m = t.style,
      u = f(t, ["disabled", "id", "name", "text", "className", "style"]),
      d = a(),
      s = d.values,
      h = d.setFieldValue,
      b = d.setFieldTouched,
      g = l(s, i),
      k = o(function () {
    h(i, !g), b(i, !0);
  }, [g]);
  return e.createElement("div", {
    className: "checkbox-input-wrapper"
  }, e.createElement("input", Object.assign({
    onChange: k
  }, u, {
    id: n || i,
    name: i,
    checked: g,
    className: c,
    style: m,
    disabled: r,
    type: "checkbox"
  })), e.createElement("label", {
    htmlFor: i,
    className: "checkbox-text"
  }, p));
};

v.defaultProps = {
  id: null,
  className: null,
  style: null,
  label: null,
  hint: null,
  text: null,
  required: !1,
  disabled: !1
};
var N = g("checkbox")(v);

var E = function (e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}(function (e) {
  var t = function (e) {
    var t = Object.prototype,
        r = t.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        n = o.iterator || "@@iterator",
        a = o.asyncIterator || "@@asyncIterator",
        i = o.toStringTag || "@@toStringTag";

    function l(e, t, r, o) {
      var n = t && t.prototype instanceof m ? t : m,
          a = Object.create(n.prototype),
          i = new v(o || []);
      return a._invoke = function (e, t, r) {
        var o = "suspendedStart";
        return function (n, a) {
          if ("executing" === o) throw new Error("Generator is already running");

          if ("completed" === o) {
            if ("throw" === n) throw a;
            return E();
          }

          for (r.method = n, r.arg = a;;) {
            var i = r.delegate;

            if (i) {
              var l = w(i, r);

              if (l) {
                if (l === c) continue;
                return l;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if ("suspendedStart" === o) throw o = "completed", r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            o = "executing";
            var m = p(e, t, r);

            if ("normal" === m.type) {
              if (o = r.done ? "completed" : "suspendedYield", m.arg === c) continue;
              return {
                value: m.arg,
                done: r.done
              };
            }

            "throw" === m.type && (o = "completed", r.method = "throw", r.arg = m.arg);
          }
        };
      }(e, r, i), a;
    }

    function p(e, t, r) {
      try {
        return {
          type: "normal",
          arg: e.call(t, r)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }

    e.wrap = l;
    var c = {};

    function m() {}

    function u() {}

    function d() {}

    var s = {};

    s[n] = function () {
      return this;
    };

    var f = Object.getPrototypeOf,
        h = f && f(f(N([])));
    h && h !== t && r.call(h, n) && (s = h);
    var b = d.prototype = m.prototype = Object.create(s);

    function g(e) {
      ["next", "throw", "return"].forEach(function (t) {
        e[t] = function (e) {
          return this._invoke(t, e);
        };
      });
    }

    function k(e) {
      var t;

      this._invoke = function (o, n) {
        function a() {
          return new Promise(function (t, a) {
            !function t(o, n, a, i) {
              var l = p(e[o], e, n);

              if ("throw" !== l.type) {
                var c = l.arg,
                    m = c.value;
                return m && "object" == typeof m && r.call(m, "__await") ? Promise.resolve(m.__await).then(function (e) {
                  t("next", e, a, i);
                }, function (e) {
                  t("throw", e, a, i);
                }) : Promise.resolve(m).then(function (e) {
                  c.value = e, a(c);
                }, function (e) {
                  return t("throw", e, a, i);
                });
              }

              i(l.arg);
            }(o, n, t, a);
          });
        }

        return t = t ? t.then(a, a) : a();
      };
    }

    function w(e, t) {
      var r = e.iterator[t.method];

      if (void 0 === r) {
        if (t.delegate = null, "throw" === t.method) {
          if (e.iterator.return && (t.method = "return", t.arg = void 0, w(e, t), "throw" === t.method)) return c;
          t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return c;
      }

      var o = p(r, e.iterator, t.arg);
      if ("throw" === o.type) return t.method = "throw", t.arg = o.arg, t.delegate = null, c;
      var n = o.arg;
      return n ? n.done ? (t[e.resultName] = n.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, c) : n : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, c);
    }

    function y(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }

    function x(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }

    function v(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(y, this), this.reset(!0);
    }

    function N(e) {
      if (e) {
        var t = e[n];
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;

        if (!isNaN(e.length)) {
          var o = -1,
              a = function t() {
            for (; ++o < e.length;) {
              if (r.call(e, o)) return t.value = e[o], t.done = !1, t;
            }

            return t.value = void 0, t.done = !0, t;
          };

          return a.next = a;
        }
      }

      return {
        next: E
      };
    }

    function E() {
      return {
        value: void 0,
        done: !0
      };
    }

    return u.prototype = b.constructor = d, d.constructor = u, d[i] = u.displayName = "GeneratorFunction", e.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === u || "GeneratorFunction" === (t.displayName || t.name));
    }, e.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, d) : (e.__proto__ = d, i in e || (e[i] = "GeneratorFunction")), e.prototype = Object.create(b), e;
    }, e.awrap = function (e) {
      return {
        __await: e
      };
    }, g(k.prototype), k.prototype[a] = function () {
      return this;
    }, e.AsyncIterator = k, e.async = function (t, r, o, n) {
      var a = new k(l(t, r, o, n));
      return e.isGeneratorFunction(r) ? a : a.next().then(function (e) {
        return e.done ? e.value : a.next();
      });
    }, g(b), b[i] = "Generator", b[n] = function () {
      return this;
    }, b.toString = function () {
      return "[object Generator]";
    }, e.keys = function (e) {
      var t = [];

      for (var r in e) {
        t.push(r);
      }

      return t.reverse(), function r() {
        for (; t.length;) {
          var o = t.pop();
          if (o in e) return r.value = o, r.done = !1, r;
        }

        return r.done = !0, r;
      };
    }, e.values = N, v.prototype = {
      constructor: v,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(x), !e) for (var t in this) {
          "t" === t.charAt(0) && r.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
        }
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var t = this;

        function o(r, o) {
          return i.type = "throw", i.arg = e, t.next = r, o && (t.method = "next", t.arg = void 0), !!o;
        }

        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var a = this.tryEntries[n],
              i = a.completion;
          if ("root" === a.tryLoc) return o("end");

          if (a.tryLoc <= this.prev) {
            var l = r.call(a, "catchLoc"),
                p = r.call(a, "finallyLoc");

            if (l && p) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            } else if (l) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
            } else {
              if (!p) throw new Error("try statement without catch or finally");
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var n = this.tryEntries[o];

          if (n.tryLoc <= this.prev && r.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
            var a = n;
            break;
          }
        }

        a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
        var i = a ? a.completion : {};
        return i.type = e, i.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, c) : this.complete(i);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), c;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];
          if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), x(r), c;
        }
      },
      catch: function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];

          if (r.tryLoc === e) {
            var o = r.completion;

            if ("throw" === o.type) {
              var n = o.arg;
              x(r);
            }

            return n;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, t, r) {
        return this.delegate = {
          iterator: N(e),
          resultName: t,
          nextLoc: r
        }, "next" === this.method && (this.arg = void 0), c;
      }
    }, e;
  }(e.exports);

  try {
    regeneratorRuntime = t;
  } catch (e) {
    Function("r", "regeneratorRuntime = r")(t);
  }
});

function z(e, t, r, o, n, a, i) {
  try {
    var l = e[a](i),
        p = l.value;
  } catch (e) {
    return void r(e);
  }

  l.done ? t(p) : Promise.resolve(p).then(o, n);
}

function F(e) {
  return function () {
    var t = this,
        r = arguments;
    return new Promise(function (o, n) {
      var a = e.apply(t, r);

      function i(e) {
        z(a, o, n, i, l, "next", e);
      }

      function l(e) {
        z(a, o, n, i, l, "throw", e);
      }

      i(void 0);
    });
  };
}

function O(e) {
  if (arguments.length < 1) throw new TypeError("1 argument required, but only " + arguments.length + " present");
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || "object" == typeof e && "[object Date]" === t ? new Date(e.getTime()) : "number" == typeof e || "[object Number]" === t ? new Date(e) : ("string" != typeof e && "[object String]" !== t || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), new Date(NaN));
}

function P(e) {
  if (arguments.length < 1) throw new TypeError("1 argument required, but only " + arguments.length + " present");
  var t = O(e);
  return !isNaN(t);
}

var j = function j(t) {
  var r = t.dateFormat,
      o = t.disabled,
      n = t.name,
      i = t.id,
      p = t.placeholder,
      c = t.onFocus,
      u = t.onBlur,
      d = t.className,
      h = t.style,
      b = f(t, ["dateFormat", "disabled", "name", "id", "placeholder", "onFocus", "onBlur", "className", "style"]),
      g = a().values,
      k = s(function (e) {
    var t = a(),
        r = t.setFieldValue,
        o = t.setFieldTouched;
    return [function (e) {
      var t = e.target,
          n = t.name,
          a = t.value;
      /^\d{0,2}[./]{0,1}\d{0,2}[./]{0,1}\d{0,4}$/.test(a) || e.preventDefault(), P(new Date(a)) && (r(n, a), o(n, !0));
    }, function () {
      var t = F(E.mark(function t(n) {
        var a;
        return E.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (a = new Date(n), !n || !P(a)) {
                  t.next = 6;
                  break;
                }

                return t.next = 4, r(e, a);

              case 4:
                t.next = 8;
                break;

              case 6:
                return t.next = 8, r(e, "");

              case 8:
                o(e, !0);

              case 9:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }()];
  }(n), 2),
      w = k[0],
      y = k[1];
  return e.createElement(m, Object.assign({
    disabledKeyboardNavigation: !0,
    autoComplete: "off"
  }, b, {
    id: i || n,
    name: n,
    className: d,
    style: h,
    selected: l(g, n) && new Date(l(g, n)),
    placeholderText: p,
    dateFormat: r,
    onChangeRaw: w,
    onChange: y,
    onFocus: c,
    onBlur: u,
    disabled: o
  }));
};

j.defaultProps = {
  id: null,
  className: null,
  style: null,
  label: null,
  hint: null,
  dateFormat: "dd/MM/yyyy",
  placeholder: null,
  required: !1,
  disabled: !1,
  onFocus: null,
  onBlur: null
};
var C = g("datePicker")(j);

function L(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function I(e, t) {
  var r = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, o);
  }

  return r;
}

var S = function S(t) {
  var r = t.disabled,
      o = t.id,
      i = t.name,
      l = t.accept,
      p = t.zoneActiveText,
      c = t.fileInfo,
      m = t.disabledText,
      d = t.placeholder,
      s = t.className,
      h = t.withClearButton,
      b = t.clearButtonText,
      g = t.multiple,
      k = f(t, ["disabled", "id", "name", "accept", "zoneActiveText", "fileInfo", "disabledText", "placeholder", "className", "withClearButton", "clearButtonText", "multiple"]),
      w = a(),
      y = w.values,
      v = w.setFieldValue,
      N = w.setFieldTouched,
      E = w.handleReset,
      z = u(function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? I(Object(r), !0).forEach(function (t) {
        L(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : I(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }({
    id: o || i,
    name: i,
    accept: l,
    onDrop: function onDrop(e) {
      var t = g ? y[i].concat(e) : e;
      v(i, t), N(i, !0);
    },
    disabled: r,
    multiple: g
  }, k)),
      F = z.getRootProps,
      O = z.getInputProps,
      P = z.isDragActive,
      j = z.acceptedFiles,
      C = z.rejectedFiles;
  return e.createElement(e.Fragment, null, e.createElement("section", null, e.createElement("div", Object.assign({}, F(), {
    className: n("dropzone", s, {
      "dropzone--isActive": P,
      "dropzone--isDisabled": r
    })
  }), r ? e.createElement("p", {
    className: "text"
  }, m) : e.createElement(e.Fragment, null, e.createElement("input", O()), j.length && y[i].length || C.length ? y[i].map(function (t) {
    return t.type.includes("image") ? e.createElement("img", {
      key: t.name,
      src: URL.createObjectURL(t),
      className: "img-thumbnail",
      alt: t.name
    }) : e.createElement("div", {
      key: t.name,
      className: "icon-wrapper"
    }, e.createElement("div", {
      className: "icon"
    }, e.createElement("i", {
      title: t.name.split(".").pop()
    })), e.createElement("p", null, t.name.split(".").shift()));
  }) : P ? e.createElement("p", {
    className: "text"
  }, p) : e.createElement("p", {
    className: "text"
  }, d), c && e.createElement("div", {
    className: "fileInfo"
  }, "Accepted ".concat(j.length, ", rejected ").concat(C.length, " files"))))), h && !r && e.createElement(x, {
    className: "clear-button",
    onClick: function onClick() {
      E();
    }
  }, b));
};

S.defaultProps = {
  className: null,
  style: null,
  disabled: !1,
  id: null,
  accept: null,
  label: null,
  zoneActiveText: "Drop file(s) here",
  fileInfo: !1,
  disabledText: "File upload disabled",
  placeholder: "Try dropping some files here, or click to select files to upload.",
  hint: null,
  required: !1,
  withClearButton: !1,
  clearButtonText: "Clear Files",
  multiple: !0
};
var T = g("dropzone")(S);
!function (e, t) {
  void 0 === t && (t = {});
  var r = t.insertAt;

  if (e && "undefined" != typeof document) {
    var o = document.head || document.getElementsByTagName("head")[0],
        n = document.createElement("style");
    n.type = "text/css", "top" === r && o.firstChild ? o.insertBefore(n, o.firstChild) : o.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
  }
}('.react-formik-ui.structured .form-element .label,.rfui-structured-label{display:flex;flex-direction:column}.react-formik-ui.structured .form-element .error,.react-formik-ui.structured .form-element .hint,.react-formik-ui.themed .form-element .error,.react-formik-ui.themed .form-element .hint,.rfui-error-hint{font-size:.8rem;display:block;margin-top:3px}.react-formik-ui.themed .form-element .autocomplete-wrapper,.react-formik-ui.themed .form-element .datePicker-wrapper,.react-formik-ui.themed .form-element .input-wrapper,.react-formik-ui.themed .form-element .phoneInput-wrapper,.react-formik-ui.themed .form-element .select-wrapper,.react-formik-ui.themed .form-element .textarea-wrapper,.rfui-themed-component{position:relative;display:flex;flex-direction:column}.react-formik-ui.themed .form-element .autocomplete-wrapper:before,.react-formik-ui.themed .form-element .datePicker-wrapper:before,.react-formik-ui.themed .form-element .input-wrapper:before,.react-formik-ui.themed .form-element .phoneInput-wrapper:before,.react-formik-ui.themed .form-element .select-wrapper:before,.react-formik-ui.themed .form-element .textarea-wrapper:before,.rfui-themed-component:before{content:"\\00a0";left:0;right:0;bottom:0;position:absolute;transition:border-bottom-color .2s cubic-bezier(.4,0,.2,1) 0ms;border-bottom:1px solid;pointer-events:none}.react-formik-ui.themed .form-element .autocomplete-wrapper:hover:before,.react-formik-ui.themed .form-element .datePicker-wrapper:hover:before,.react-formik-ui.themed .form-element .input-wrapper:hover:before,.react-formik-ui.themed .form-element .phoneInput-wrapper:hover:before,.react-formik-ui.themed .form-element .select-wrapper:hover:before,.react-formik-ui.themed .form-element .textarea-wrapper:hover:before,.rfui-themed-component:hover:before{border-bottom:2px solid}.react-formik-ui.themed .form-element .isDisabled.autocomplete-wrapper:before,.react-formik-ui.themed .form-element .isDisabled.datePicker-wrapper:before,.react-formik-ui.themed .form-element .isDisabled.input-wrapper:before,.react-formik-ui.themed .form-element .isDisabled.phoneInput-wrapper:before,.react-formik-ui.themed .form-element .isDisabled.select-wrapper:before,.react-formik-ui.themed .form-element .isDisabled.textarea-wrapper:before,.rfui-themed-component.isDisabled:before{border-bottom:1px dotted rgba(0,0,0,.42)}.react-formik-ui.themed .form-element .hasError.autocomplete-wrapper,.react-formik-ui.themed .form-element .hasError.datePicker-wrapper,.react-formik-ui.themed .form-element .hasError.input-wrapper,.react-formik-ui.themed .form-element .hasError.phoneInput-wrapper,.react-formik-ui.themed .form-element .hasError.select-wrapper,.react-formik-ui.themed .form-element .hasError.textarea-wrapper,.rfui-themed-component.hasError{color:#c00}.react-formik-ui.themed .form-element .autocomplete-wrapper .label,.react-formik-ui.themed .form-element .datePicker-wrapper .label,.react-formik-ui.themed .form-element .input-wrapper .label,.react-formik-ui.themed .form-element .phoneInput-wrapper .label,.react-formik-ui.themed .form-element .textarea-wrapper .label,.rfui-themed-label{font-size:1em;line-height:100%;position:absolute;left:2px;top:50%;transform:translateY(-50%);transition:all .25s cubic-bezier(.4,0,.2,1);pointer-events:none}.react-formik-ui.themed .form-element .autocomplete-wrapper .label+input,.react-formik-ui.themed .form-element .datePicker-wrapper .label+input,.react-formik-ui.themed .form-element .input-wrapper .label+input,.react-formik-ui.themed .form-element .phoneInput-wrapper .label+input,.react-formik-ui.themed .form-element .textarea-wrapper .label+input,.rfui-themed-label+input{opacity:0;transition:opacity .25s ease-in-out}.react-formik-ui.themed .form-element .autocomplete-wrapper .moveLabel.label,.react-formik-ui.themed .form-element .datePicker-wrapper .moveLabel.label,.react-formik-ui.themed .form-element .input-wrapper .moveLabel.label,.react-formik-ui.themed .form-element .phoneInput-wrapper .moveLabel.label,.react-formik-ui.themed .form-element .textarea-wrapper .moveLabel.label,.rfui-themed-label.moveLabel{left:45px}.react-formik-ui.themed .form-element .autocomplete-wrapper .hide.label,.react-formik-ui.themed .form-element .datePicker-wrapper .hide.label,.react-formik-ui.themed .form-element .input-wrapper .hide.label,.react-formik-ui.themed .form-element .phoneInput-wrapper .hide.label,.react-formik-ui.themed .form-element .textarea-wrapper .hide.label,.rfui-themed-label.hide{font-size:.9em;top:-5px;left:2px;pointer-events:all}.react-formik-ui.themed .form-element .autocomplete-wrapper .hide.label+input,.react-formik-ui.themed .form-element .datePicker-wrapper .hide.label+input,.react-formik-ui.themed .form-element .input-wrapper .hide.label+input,.react-formik-ui.themed .form-element .phoneInput-wrapper .hide.label+input,.react-formik-ui.themed .form-element .textarea-wrapper .hide.label+input,.rfui-themed-label.hide+input{opacity:1}.react-formik-ui.themed .form-element .autocomplete-wrapper input,.react-formik-ui.themed .form-element .datePicker-wrapper input,.react-formik-ui.themed .form-element .input-wrapper input,.react-formik-ui.themed .form-element .phoneInput-wrapper input,.rfui-themed-input{outline:none;font-size:1em;text-rendering:auto;letter-spacing:normal;word-spacing:normal;text-transform:none;text-indent:0;text-shadow:none;border:none;height:auto;width:auto;padding:6px 2px 7px;border-radius:none;color:currentColor;background:transparent}.react-formik-ui.themed .form-element .autocomplete-wrapper input:-webkit-autofill,.react-formik-ui.themed .form-element .datePicker-wrapper input:-webkit-autofill,.react-formik-ui.themed .form-element .input-wrapper input:-webkit-autofill,.react-formik-ui.themed .form-element .phoneInput-wrapper input:-webkit-autofill,.rfui-themed-input:-webkit-autofill{animation-name:onAutoFillStart;transition:background-color 50000s ease-in-out 0s}.react-formik-ui.themed .form-element .autocomplete-wrapper input:not(:-webkit-autofill),.react-formik-ui.themed .form-element .datePicker-wrapper input:not(:-webkit-autofill),.react-formik-ui.themed .form-element .input-wrapper input:not(:-webkit-autofill),.react-formik-ui.themed .form-element .phoneInput-wrapper input:not(:-webkit-autofill),.rfui-themed-input:not(:-webkit-autofill){animation-name:onAutoFillCancel}.react-formik-ui.themed .form-element .autocomplete-wrapper input:disabled,.react-formik-ui.themed .form-element .datePicker-wrapper input:disabled,.react-formik-ui.themed .form-element .input-wrapper input:disabled,.react-formik-ui.themed .form-element .phoneInput-wrapper input:disabled,.rfui-themed-input:disabled{color:rgba(0,0,0,.42)}.react-formik-ui .form-element.hidden{display:none}.react-formik-ui.structured .form-element{margin-bottom:10px}.react-formik-ui.themed .form-element{margin-bottom:25px}.react-formik-ui.structured .form-element .error,.react-formik-ui.themed .form-element .error{color:#c00}.react-formik-ui.structured .form-element .hint,.react-formik-ui.themed .form-element .hint{color:#909090}.react-formik-ui .form-element .suggestions li.suggestion-active,.react-formik-ui .form-element .suggestions li:hover{background-color:#ddd;color:currentColor;cursor:pointer}.react-formik-ui.structured .form-element .suggestions{border:1px solid #ccc;border-top:0 solid #ccc;list-style:none;margin-top:0;overflow-y:auto;padding-left:0}.react-formik-ui.structured .form-element .suggestions li{padding:.5rem}.react-formik-ui.structured .form-element .suggestions li:not(:last-of-type){border-bottom:1px solid #ccc}.react-formik-ui.themed .form-element .autocomplete-wrapper .suggestions{position:absolute;top:35px;list-style:none;margin-top:0;overflow-y:auto;padding-left:0;width:100%;background:#fff;box-shadow:0 1px 5px 0 rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12)}.react-formik-ui.themed .form-element .autocomplete-wrapper .suggestions li{padding:.5rem}.react-formik-ui.themed .form-element .autocomplete-wrapper .suggestions li.suggestion-active,.react-formik-ui.themed .form-element .autocomplete-wrapper .suggestions li:hover{background-color:#2d85f9;color:#fff;cursor:pointer;font-weight:600}.react-formik-ui.structured .form-element .checkbox-input-wrapper{display:flex;align-items:flex-start}.react-formik-ui.structured .form-element .checkbox-input-wrapper label{display:block;margin-left:5px}.react-formik-ui.structured .form-element .checkbox-text{display:initial;margin-bottom:0}.react-formik-ui.themed .form-element .checkbox-wrapper .label{display:block;padding-bottom:6px}.react-formik-ui.themed .form-element .checkbox-wrapper .checkbox-input-wrapper{display:flex;margin-bottom:10px;align-items:flex-end}.react-formik-ui.themed .form-element .checkbox-wrapper .checkbox-input-wrapper input[type=checkbox]{outline:none;position:absolute;opacity:0}.react-formik-ui.themed .form-element .checkbox-wrapper .checkbox-input-wrapper input[type=checkbox]+label{position:relative;cursor:pointer;padding:0}.react-formik-ui.themed .form-element .checkbox-wrapper .checkbox-input-wrapper input[type=checkbox]+label:before{content:"";margin-right:8px;display:inline-block;vertical-align:text-top;width:18px;height:17px;border:1px solid #ccc}.react-formik-ui.themed .form-element .checkbox-wrapper .checkbox-input-wrapper input[type=checkbox]:hover+label:before{background:#ddd}.react-formik-ui.themed .form-element .checkbox-wrapper .checkbox-input-wrapper input[type=checkbox]:checked+label:before{background:#065fd4}.react-formik-ui.themed .form-element .checkbox-wrapper .checkbox-input-wrapper input[type=checkbox]:checked+label:after{content:"";position:absolute;left:5px;top:8px;background:#fff;width:2px;height:2px;box-shadow:2px 0 0 #fff,4px 0 0 #fff,4px -2px 0 #fff,4px -4px 0 #fff,4px -6px 0 #fff,4px -8px 0 #fff;transform:rotate(45deg)}.react-formik-ui.themed .form-element .checkbox-wrapper .checkbox-input-wrapper input[type=checkbox]:disabled+label{color:rgba(0,0,0,.42);cursor:auto}.react-formik-ui.themed .form-element .checkbox-wrapper .checkbox-input-wrapper input[type=checkbox]:disabled+label:before{box-shadow:none;border:1px dotted rgba(0,0,0,.42);background:#ddd}.react-formik-ui .form-element .datePicker-wrapper .react-datepicker-popper{z-index:10}.react-formik-ui.themed .form-element .datePicker-wrapper{width:171px}.react-formik-ui.themed .form-element .datePicker-wrapper .react-datepicker-popper{min-width:400px}@keyframes progress{0%{background-position:0 0}to{background-position:-70px 0}}.react-formik-ui .form-element .dropzone-wrapper .label{display:block;margin-bottom:6px}.react-formik-ui .form-element .dropzone-wrapper .dropzone{width:100%;height:auto;display:flex;flex-flow:row wrap;padding:10px;box-sizing:border-box;border:2px dashed #c8c8c8;outline:none;background-color:#f0f0f0;cursor:pointer}.react-formik-ui .form-element .dropzone-wrapper .dropzone p.text{width:100%;text-align:center;color:#787878}.react-formik-ui .form-element .dropzone-wrapper .dropzone--isActive{border:2px solid;background-image:repeating-linear-gradient(-45deg,#f0f0f0,#f0f0f0 25px,#c8c8c8 0,#c8c8c8 50px);animation:progress 1s linear infinite!important;background-size:150% 100%}.react-formik-ui .form-element .dropzone-wrapper .dropzone--isDisabled{background-color:#fff;opacity:.5}.react-formik-ui .form-element .dropzone-wrapper .dropzone--isDisabled p.text{color:#000}.react-formik-ui .form-element .dropzone-wrapper .dropzone img{max-height:130px;margin:0 8px 8px 0;transition:opacity .8s;border-radius:5px;object-fit:contain}.react-formik-ui .form-element .dropzone-wrapper .dropzone .icon-wrapper{width:45px;margin:5px 5px 0}.react-formik-ui .form-element .dropzone-wrapper .dropzone .icon-wrapper p{font-size:10px;text-align:center;line-height:10px;word-break:break-all;margin:5px 0}.react-formik-ui .form-element .dropzone-wrapper .dropzone .icon-wrapper .icon{height:55px;border-radius:2px;cursor:pointer;position:relative;background-color:#065fd4;box-sizing:border-box;overflow:hidden}.react-formik-ui .form-element .dropzone-wrapper .dropzone .icon-wrapper .icon:after{content:"";position:absolute;display:block;top:0;right:0;width:0;height:0;border-radius:0 2px;transition:all .2s linear;backface-visibility:hidden;background:linear-gradient(45deg,#2d85f9 50%,#f0f0f0 0)}.react-formik-ui .form-element .dropzone-wrapper .dropzone .icon-wrapper .icon i{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:block;font-size:10px;color:#fff;font-weight:500}.react-formik-ui .form-element .dropzone-wrapper .dropzone .icon-wrapper .icon i:after,.react-formik-ui .form-element .dropzone-wrapper .dropzone .icon-wrapper .icon i:before{display:block;transition:all .2s linear}.react-formik-ui .form-element .dropzone-wrapper .dropzone .icon-wrapper .icon i:before{content:"< >";text-align:center;font-size:12px;opacity:0;transform:translateY(5px)}.react-formik-ui .form-element .dropzone-wrapper .dropzone .icon-wrapper .icon i:after{content:attr(title);text-align:center;transform:translateY(-7px)}.react-formik-ui .form-element .dropzone-wrapper .dropzone .icon-wrapper .icon:hover{border-radius:2px 4px 2px 2px}.react-formik-ui .form-element .dropzone-wrapper .dropzone .icon-wrapper .icon:hover:after{width:12px;height:12px}.react-formik-ui .form-element .dropzone-wrapper .dropzone .icon-wrapper .icon:hover i:before{transform:translateY(0);opacity:1}.react-formik-ui .form-element .dropzone-wrapper .dropzone .icon-wrapper .icon:hover i:after{transform:translateY(0)}.react-formik-ui .form-element .dropzone-wrapper .dropzone .fileInfo{width:100%;text-align:left;padding-top:10px}.react-formik-ui .form-element .dropzone-wrapper .dropzone:hover img{opacity:.3}.react-formik-ui .form-element .dropzone-wrapper .dropzone:hover img:hover{opacity:1}.react-formik-ui .form-element .dropzone-wrapper .clear-button{margin-top:10px}.react-formik-ui.themed .form-element .phoneInput-wrapper .react-phonenr-input{padding-top:3px;max-width:100%}.react-formik-ui.themed .form-element .phoneInput-wrapper .react-phonenr-input div{background-color:#fff;border:none}.react-formik-ui .form-element .radio-wrapper .label{display:block;margin-bottom:6px}.react-formik-ui .form-element .radio-wrapper .radio-options.inline{display:flex;justify-content:flex-start}.react-formik-ui .form-element .radio-wrapper .radio-options.inline .radio-option{margin-right:10px}.react-formik-ui.structured .form-element .radio-wrapper .radio-options .radio-option{display:flex;align-items:center;margin:0 0 0 5px}.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option{margin-bottom:5px}.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:checked,.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:not(:checked){position:absolute;left:-9999px}.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:checked:disabled+label,.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:not(:checked):disabled+label{color:rgba(0,0,0,.42)}.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:checked:disabled+label:before,.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:not(:checked):disabled+label:before{border:1px dotted}.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:checked:disabled:hover+label:before,.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:not(:checked):disabled:hover+label:before{background:transparent}.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:checked+label,.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:not(:checked)+label{position:relative;padding-left:28px;cursor:pointer;line-height:20px;display:inline-block}.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:checked+label:before,.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:not(:checked)+label:before{content:"";position:absolute;left:0;top:0;width:18px;height:18px;border:1px solid #ccc;border-radius:100%}.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:checked+label:after,.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:not(:checked)+label:after{content:"";width:12px;height:12px;background:#065fd4;position:absolute;top:4px;left:4px;border-radius:100%;-webkit-transition:all .2s ease;transition:all .2s ease}.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:checked+label:after{opacity:1;-webkit-transform:scale(1);transform:scale(1)}.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:not(:checked)+label:after{opacity:0;-webkit-transform:scale(0);transform:scale(0)}.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:not(:checked):hover+label:before{background:#ddd}.react-formik-ui.themed .form-element .radio-wrapper .radio-options .radio-option input[type=radio]:checked:disabled+label:after{background:rgba(0,0,0,.42)}.react-formik-ui.themed .form-element .select-wrapper{margin:0}.react-formik-ui.themed .form-element .select-wrapper:after{content:"";width:0;height:0;border:7px solid transparent;border-top-color:currentcolor;position:absolute;right:5px;top:50%;transform:translateY(-50%);pointer-events:none;cursor:pointer}.react-formik-ui.themed .form-element .select-wrapper select{-moz-appearance:none;-webkit-appearance:none;appearance:none;outline:none;background:transparent;border:none;width:100%;height:31px;font-size:1em;padding-right:25px;cursor:pointer}.react-formik-ui.themed .form-element .select-wrapper select[multiple]{height:auto;padding-right:0}.react-formik-ui.themed .form-element .select-wrapper select::-ms-expand{display:none}.react-formik-ui.themed .form-element .select-wrapper select:focus::-ms-value{background-color:transparent}.react-formik-ui.themed .form-element .select-wrapper select:disabled{color:rgba(0,0,0,.42)}.react-formik-ui.themed .form-element .select-wrapper.multiple:after{border:none}.react-formik-ui.themed .form-element .textarea-wrapper .label{top:24px}.react-formik-ui.themed .form-element .textarea-wrapper .label.hide{top:10px}.react-formik-ui.themed .form-element .textarea-wrapper textarea{outline:none;resize:none;font-size:1em;text-rendering:auto;letter-spacing:normal;word-spacing:normal;text-transform:none;text-indent:0;text-shadow:none;border:none;min-height:120px;width:auto;padding:24px 0 6px;border-radius:0;color:currentColor;background:transparent;box-sizing:border-box;transition:border-bottom-color .2s cubic-bezier(.4,0,.2,1) 0ms}.react-formik-ui.themed .form-element .textarea-wrapper textarea:disabled{color:rgba(0,0,0,.42)}.toggle-switch{position:relative;display:inline-block;width:40px;height:12px}.toggle-switch>input{display:none}.toggle-switch>input:checked+.slider:before{transform:translate(20px,-50%);background-color:#065fd4}.toggle-switch .slider{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ddd;box-shadow:inset 0 0 5px rgba(0,0,0,.6);transition:.4s;border-radius:15px}.toggle-switch .slider:before{content:"";position:absolute;top:50%;height:20px;width:20px;transform:translateY(-50%);background-color:#eee;box-shadow:0 1px 5px 0 rgba(0,0,0,.6);transition:all .2s cubic-bezier(.4,0,.2,1);border-radius:50%}');

var D = function D(t) {
  var r = t.children,
      o = t.className,
      a = t.mode,
      i = f(t, ["children", "className", "mode"]);
  return e.createElement(p, Object.assign({}, i, {
    className: n("react-formik-ui form-wrapper", a, o)
  }), r);
};

D.defaultProps = {
  className: null,
  mode: "default"
};

var B = r(D),
    A = function A(t) {
  var r = t.disabled,
      o = t.id,
      n = t.name,
      i = t.placeholder,
      p = t.type,
      c = t.onAnimationStart,
      m = t.onFocus,
      u = t.onBlur,
      d = t.className,
      s = t.style,
      h = f(t, ["disabled", "id", "name", "placeholder", "type", "onAnimationStart", "onFocus", "onBlur", "className", "style"]),
      b = a(),
      g = b.values,
      k = b.handleChange;
  return e.createElement("input", Object.assign({
    value: l(g, n),
    onChange: k,
    onFocus: m,
    onBlur: u
  }, h, {
    id: o || n,
    name: n,
    className: d,
    style: s,
    type: p,
    onAnimationStart: c,
    placeholder: i,
    disabled: r
  }));
};

A.defaultProps = {
  onFocus: null,
  onBlur: null,
  className: null,
  style: null,
  disabled: !1,
  id: null,
  label: null,
  placeholder: null,
  type: "text",
  hint: null,
  required: !1
};

var q = g("input")(A),
    _ = function _(t) {
  var r = t.id,
      o = t.name,
      n = t.placeholder,
      i = t.disabled,
      l = t.hint,
      p = t.required,
      c = t.format,
      m = t.defaultCountry,
      u = t.preferredCountries,
      s = t.regions,
      h = t.buttonFlagStyles,
      b = t.listFlagStyles,
      g = t.className,
      k = t.style,
      w = t.withCountryMeta,
      y = f(t, ["id", "name", "placeholder", "disabled", "hint", "required", "format", "defaultCountry", "preferredCountries", "regions", "buttonFlagStyles", "listFlagStyles", "className", "style", "withCountryMeta"]),
      x = a().setFieldValue,
      v = function () {
    var e = F(E.mark(function e(t) {
      return E.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, x(o, t);

            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }();

  return e.createElement(d, Object.assign({
    onChange: v
  }, y, {
    id: r || o,
    name: o,
    className: g,
    style: k,
    placeholder: n,
    disabled: i,
    hint: l,
    required: p,
    format: c,
    defaultCountry: m,
    preferredCountries: u,
    regions: s,
    buttonFlagStyles: h,
    listFlagStyles: b,
    withCountryMeta: w
  }));
};

_.defaultProps = {
  className: null,
  style: null,
  id: null,
  label: null,
  placeholder: null,
  defaultCountry: null,
  preferredCountries: [],
  regions: null,
  format: "INTERNATIONAL",
  buttonFlagStyles: null,
  listFlagStyles: null,
  disabled: !1,
  hint: null,
  required: !1,
  withCountryMeta: !1
};

var M = g("phoneInput")(_),
    R = function R(t) {
  var r = t.disabled,
      o = t.name,
      i = t.options,
      p = t.inline,
      c = t.className,
      m = t.style,
      u = f(t, ["disabled", "name", "options", "inline", "className", "style"]),
      d = a(),
      s = d.values,
      h = d.handleChange,
      b = d.handleBlur;
  return e.createElement("div", {
    className: n("radio-options", {
      inline: p
    })
  }, i.map(function (t) {
    return e.createElement("div", {
      key: t.label,
      className: "radio-option"
    }, e.createElement("input", Object.assign({
      className: c,
      style: m,
      onChange: h
    }, u, {
      checked: l(s, o) === t.value,
      id: "".concat(o, "-id-").concat(t.value),
      value: t.value,
      onBlur: b,
      name: o,
      disabled: r,
      type: "radio"
    })), e.createElement("label", {
      htmlFor: "".concat(o, "-id-").concat(t.value)
    }, t.label));
  }));
};

R.defaultProps = {
  className: null,
  style: null,
  label: null,
  disabled: !1,
  inline: !1,
  hint: null,
  required: !1
};

var Y = g("radio")(R),
    G = function G(t) {
  var r = t.disabled,
      o = t.id,
      n = t.label,
      i = t.name,
      p = t.options,
      c = t.placeholder,
      m = t.required,
      u = t.className,
      d = t.style,
      s = t.multiple,
      h = f(t, ["disabled", "id", "label", "name", "options", "placeholder", "required", "className", "style", "multiple"]),
      b = a(),
      g = b.values,
      k = b.handleChange,
      w = b.setFieldValue;
  return e.createElement("select", Object.assign({
    onChange: s ? function (e) {
      return w(i, [].slice.call(e.target.selectedOptions).map(function (e) {
        return e.value;
      }));
    } : k
  }, h, {
    id: o || i,
    name: i,
    className: u,
    style: d,
    value: l(g, i),
    disabled: r,
    multiple: s
  }), c && e.createElement("option", {
    value: ""
  }, "".concat(c).concat(!n && m ? " *" : "")), p.map(function (t) {
    return e.createElement("option", {
      key: t.label,
      value: t.value
    }, t.label);
  }));
};

G.defaultProps = {
  className: null,
  style: null,
  disabled: !1,
  id: null,
  label: null,
  placeholder: null,
  hint: null,
  required: !1,
  multiple: !1
};

var V = g("select")(G),
    K = function K(t) {
  var r = t.className,
      o = t.disabled,
      i = t.children,
      l = f(t, ["className", "disabled", "children"]),
      p = a().handleSubmit;
  return e.createElement("button", Object.assign({
    className: n("form-element btn submit-btn", r, {
      isDisabled: o
    }),
    onClick: p,
    type: "submit",
    disabled: o
  }, l), i);
};

K.defaultProps = {
  className: null,
  disabled: !1,
  children: "Submit"
};

var U = r(K),
    W = function W(t) {
  var r = t.disabled,
      o = t.id,
      n = t.name,
      i = t.placeholder,
      p = t.onFocus,
      c = t.onBlur,
      m = t.className,
      u = t.style,
      d = f(t, ["disabled", "id", "name", "placeholder", "onFocus", "onBlur", "className", "style"]),
      s = a(),
      h = s.values,
      b = s.handleChange;
  return e.createElement("textarea", Object.assign({
    onChange: b
  }, d, {
    id: o || n,
    name: n,
    placeholder: i,
    value: l(h, n),
    onFocus: p,
    onBlur: c,
    disabled: r,
    className: m,
    style: u
  }));
};

W.defaultProps = {
  onFocus: null,
  onBlur: null,
  className: null,
  style: null,
  disabled: !1,
  id: null,
  label: null,
  placeholder: null,
  hint: null,
  required: !1
};

var Z = g("textarea")(W),
    $ = function $(t) {
  var r = t.className,
      i = t.disabled,
      p = t.name,
      c = t.style,
      m = t.id,
      u = f(t, ["className", "disabled", "name", "style", "id"]),
      d = a(),
      s = d.values,
      h = d.setFieldValue,
      b = d.setFieldTouched,
      g = l(s, p),
      k = o(function () {
    h(p, !g), b(p, !0);
  }, [g]);
  return e.createElement("div", {
    className: n("form-element", "toggle-wrapper", r, {
      isDisabled: i
    }),
    style: c
  }, e.createElement("label", {
    className: n("toggle-switch", r)
  }, e.createElement("input", Object.assign({
    onChange: k
  }, u, {
    name: p,
    id: m || p,
    checked: g,
    disabled: i,
    type: "checkbox"
  })), e.createElement("span", {
    className: "slider"
  })));
};

$.defaultProps = {
  className: null,
  style: null,
  disabled: !1,
  id: null
};
export { w as Autocomplete, x as Button, N as Checkbox, C as Datepicker, T as DropZone, B as Form, q as Input, M as PhoneInput, Y as Radio, V as Select, U as SubmitBtn, Z as Textarea, $ as Toggle };